module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c06-b94ee5053cbe9be975f4413d16ade49c.jpg";